<template>
  <div class="date_selector">
    <button-icon
      class="date_button"
      icon="left"
      size="is-large"
      :disabled="disablePrevious"
      @click="previousDate"
    />

    <div class="has-text-centered">
      <p class="today_text">{{ isToday ? 'Today' : '' }}</p>
      <p :class="['date_text', {'has-text-danger': month === 'Past Due'}]">{{ month }} {{ day }}</p>
    </div>

    <button-icon
      class="date_button"
      icon="right"
      size="is-large"
      @click="nextDate"
    />
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "DateSelector",
  props: {
    value: String,
    includePastDue: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isToday() {
      return dates.isToday(this.value)
    },
    month() {
      if(this.value === null) {
        return 'Past Due'
      }

      return dates.formatAsMonthLong(this.value, false)
    },
    day() {
      return dates.formatAsDay(this.value, false)
    },
    disablePrevious() {
      return this.includePastDue && this.value === null;
    }
  },
  methods: {
    previousDate() {
      let previous = dates.subtractDay(this.value);

      if(this.includePastDue && this.isToday) {
        previous = null;
      }

      this.$emit('input', previous);
    },
    nextDate() {
      let next = dates.addDay(this.value);

      if(this.value === null) {
        next = dates.getTodayISO();
      }

      this.$emit('input', next);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.date_selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid $border;
}

.date_button {
  height: 2rem!important;
  width: 2rem!important;
}

.today_text {
  height: 0.75rem;
  font-size: 0.75rem;
  line-height: 1;
  color: $text-light;
}

.date_text {
  font-size: 1.125rem;
}
</style>
